import type { QuestionOutcome } from '../ui/useSinglePlayerQuizController';

/** Per-format answered/correct counts, stored on singleplayer_results.format_stats. */
export type FormatStats = Record<string, { answered: number; correct: number }>;

/**
 * Summarize one quiz's outcomes by question format. Questions without a known
 * format are counted under "unknown" so totals still add up. The achievement
 * evaluator reads `true_false` and `mcq_multiple`.
 */
export const summarizeFormatOutcomes = (outcomes: ReadonlyArray<QuestionOutcome | undefined>): FormatStats => {
  const stats: FormatStats = {};
  for (const outcome of outcomes) {
    if (!outcome) continue;
    const key = outcome.question_type || 'unknown';
    const bucket = (stats[key] ??= { answered: 0, correct: 0 });
    bucket.answered += 1;
    if (outcome.isCorrect) bucket.correct += 1;
  }
  return stats;
};
